module.exports = __webpack_public_path__ + "4f92efa471ca5945db4865305ec15185.png";